import { render, staticRenderFns } from "./SelectConcedente.vue?vue&type=template&id=35fa12c4"
import script from "./SelectConcedente.vue?vue&type=script&lang=js"
export * from "./SelectConcedente.vue?vue&type=script&lang=js"
import style0 from "./SelectConcedente.vue?vue&type=style&index=0&id=35fa12c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports